import { RootState } from '../../../common/store/store'

export const hipUsersState = (state: RootState) => state.hipUsers
